import React, {Component} from 'react';
import {WINDOW} from '../../constants/environment'
import './styles.css';

export default class ScrollLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    let flg = false;
    if (this.ref.current) {
      const parentElement = this.ref.current.closest('.PromoAndButtonModalWindow-Modal') || null;
      if (parentElement) {
        flg = true;
      }
    }

    if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true,
      });
    } else if (flg) {
      // プロモモーダルブロックのモーダル内の処理
      this.setState({
        opened: true,
      });
    } else {
      WINDOW.addEventListener('resize', this.handleScrollAndResize);
      WINDOW.addEventListener('scroll', this.handleScrollAndResize);
      setTimeout(() => {
        this.handleScrollAndResize();
      }, 200);
    }
  }

  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.handleScrollAndResize);
    WINDOW.removeEventListener('scroll', this.handleScrollAndResize);
  }

  render() {
    return (
      <div className={'ScrollLoader' + ((this.state.opened === true)  ? ' opened' : '')} ref={this.ref}>
        {(this.state.opened === true)  ? this.props.children : null}
      </div>
    );
  }

  //
  handleScrollAndResize = () => {
    if (this.state.opened === true) return;
    const element = this.ref.current;
    const scrollTop = WINDOW.pageYOffset;
    const clientRect = element.getBoundingClientRect();
    const top = scrollTop + clientRect.top;
    const windowHeight = WINDOW.innerHeight;
    if ((windowHeight / 3) <= windowHeight - (top - scrollTop)) {
      if (this.state.opened === false) {
        this.setState({
          opened: true,
        });
        WINDOW.removeEventListener('resize', this.handleScrollAndResize);
        WINDOW.removeEventListener('scroll', this.handleScrollAndResize);
      }
    }
  };

}



// WEBPACK FOOTER //
// ./src/components/scroll-loader/index.jsx